import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { getBankStatementEducation } from '@marketplace-web/pay-identity/pay-identity-kyc-data'

const useFetchBankEducation = () => {
  const {
    fetch: fetchBankStatementEducation,
    data,
    isLoading,
    error,
  } = useFetch(getBankStatementEducation)

  useEffect(() => {
    fetchBankStatementEducation()
  }, [fetchBankStatementEducation])

  return { data, isLoading, error }
}

export default useFetchBankEducation
